import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { api } from "@/lib/api";
import { Store, BadgeCheck, Package, ArrowLeft } from "lucide-react";
import GlobalAppHeader from "@/components/shared/GlobalAppHeader";
import GlobalAppFooter from "@/components/shared/GlobalAppFooter";

export default function VendorPublic() {
  const { id } = useParams();
  const [v, setV] = useState(null);
  const [products, setProducts] = useState([]);
  useEffect(() => {
    api.get(`/store/vendors/${id}`).then(r => setV(r.data)).catch(() => {});
    api.get("/store/products", { params: { vendor_id: id } }).then(r => setProducts(r.data)).catch(() => {});
  }, [id]);
  if (!v) return <div className="min-h-screen grid place-items-center mono">Loading…</div>;
  const offers = products.filter(p => p.mrp > p.selling_price).slice(0, 6);
  return (
    <div className="min-h-screen pf-app max-w-full overflow-x-hidden">
      <GlobalAppHeader />
      <div className="h-40 bg-[#93C5FD] border-b-2 border-black flex items-end">
        <div className="max-w-5xl mx-auto w-full px-6 pb-4 flex items-center gap-3">
          <div className="w-16 h-16 bg-white border-2 border-black rounded grid place-items-center"><Store size={28} /></div>
          <div>
            <h1 className="display text-3xl font-black flex items-center gap-2">{v.business_name}
              {v.kyc_status === "VERIFIED" && <BadgeCheck size={22} className="text-green-700" data-testid="vendor-verified" />}</h1>
            <div className="text-sm">{v.city} · {v.postal_code}</div>
          </div>
        </div>
      </div>
      <main className="max-w-5xl mx-auto p-6 space-y-6">
        <Link to="/store" className="nb-btn nb-btn-ghost text-xs"><ArrowLeft size={14} /> Back to Store</Link>
        {offers.length > 0 && <section>
          <h2 className="display text-xl font-bold mb-2">Current Offers</h2>
          <div className="flex gap-3 overflow-x-auto pb-2">
            {offers.map(p => <div key={p.product_id} className="min-w-[180px] nb-card bg-[#FDE047] p-3">
              <div className="font-bold text-sm">{p.title}</div>
              <div className="mono">₹{p.selling_price} <span className="line-through opacity-50 text-xs">₹{p.mrp}</span></div>
            </div>)}
          </div>
        </section>}
        <section data-testid="vendor-catalog">
          <h2 className="display text-xl font-bold mb-2">Full Catalog</h2>
          <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-4">
            {products.map(p => (
              <div key={p.product_id} className="nb-card bg-white p-4">
                <div className="h-24 bg-[#FAF7F0] border-2 border-black rounded grid place-items-center mb-2 overflow-hidden">
                  {p.image_url ? <img src={p.image_url} alt={p.title} className="w-full h-full object-cover" /> : <Package size={28} className="opacity-40" />}
                </div>
                <div className="font-bold text-sm">{p.title}</div>
                <div className="text-xs opacity-60">{p.category_code}</div>
                <div className="mono font-black">₹{p.selling_price}</div>
              </div>
            ))}
            {products.length === 0 && <div className="col-span-full text-center py-8 text-slate-500">No products listed.</div>}
          </div>
        </section>
      </main>
      <GlobalAppFooter />
    </div>
  );
}
